<template>
  <div
    class="border pr-3 pl-4 py-1 mb-2 flex text-red-600 border-red-400 bg-red-100 dark:text-dark-text dark:border-red-900 dark:bg-red-900"
    style="user-select: contain; border-radius: 1rem"
  >
    <div class="flex">
      <span class="material-icons text-xl pr-3">error</span>
      <div class="w-full my-auto">{{ text }}</div>
      <div>
        <button class="focus:outline-none" style="user-select: none" @click="close()">
          <span class="material-icons text-xl"> close </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    },
    close: {
      type: Function,
      required: true
    }
  },
  setup() {
    return {}
  }
})
</script>

<style></style>
